<div class="grow-project-detail dialog">
  <div class="dialog-background" (click)="onClose()"></div>
  <div class="dialog-content">
    <a class="close" (click)="onClose()"><i class="icon-i-close"></i></a>
    <div class="inner-scroll">
      <app-grow-project-detail
        class="project-detail"
        [growAccount]="growAccount"
        [project]="project"
        [language]="language"
        (activeTabChange)="onTabChanged($event)"
      ></app-grow-project-detail>
    </div>
    <div *ngIf="isMarked$ | async; else notMarked">
      <app-ds-button (clicked)="unmarkProject()" variant="outline">{{ 'GROW.project.buttons.deselectProject' | translate }}</app-ds-button>
    </div>
    <ng-template #notMarked>
      <app-ds-button (clicked)="markProject()">{{ 'GROW.project.buttons.selectProject' | translate }}</app-ds-button>
    </ng-template>
  </div>
</div>
